import { FC } from "react";

import { CardBrandWrapperProps } from "./types";
import CardBrand from "../CardBrand/CardBrand";
import CardSkeleton from "../CardSkeleton/CardSkeleton";
import DataLoadError from "../DataLoadError";

const CardBrandWrapper: FC<CardBrandWrapperProps> = ({
  loading,
  brands,
  skeletonCount = 1,
  error,
  onRetry,
  openBrandId = null,
}) => {
  const renderSkeletons = () => {
    return Array.from({ length: skeletonCount }).map((_, index) => (
      <CardSkeleton key={index} />
    ));
  };

  if (loading) return renderSkeletons();

  if (!brands && error) {
    return (
      <DataLoadError
        message={error}
        onRetry={onRetry}
      />
    );
  }

  if (!brands) return renderSkeletons();

  const renderBrands = () => {
    if (Array.isArray(brands)) {
      return brands.map((brand) => (
        <CardBrand
          key={brand.id}
          brand={brand}
          defaultIsOpen={openBrandId != null && brand.id === openBrandId}
        />
      ));
    }

    return (
      <CardBrand
        key={brands.id}
        brand={brands}
        defaultIsOpen={openBrandId != null && brands.id === openBrandId}
      />
    );
  };

  return (
    <div>{ renderBrands() }</div>
  );
};

export default CardBrandWrapper;